import { createReducer } from "typesafe-actions";

import { MAX_LASSO_PATHS } from "@app/util/lasso";

import {
  Actions,
  addToRouteSelection,
  appendRouteLassoPath,
  cleanRouteLassoPaths,
  clearRouteSelection,
  fetchRouteLassoSelection,
  removeFromRouteSelection,
  restartRouteSelection,
  setRouteLassoContainsFlags,
  setRouteRulerPath,
  setRouteSelection,
  setRouteSelectionEntities,
  setRouteTool,
} from "../../actions";
import { initialMapState, RouteMapState } from "../state";

export const toolsReducer = createReducer<RouteMapState, Actions>(initialMapState)
  .handleAction(setRouteTool, (state, { payload }) => ({
    ...state,
    tool: payload,
  }))
  .handleAction(setRouteRulerPath, (state, { payload }) => ({
    ...state,
    rulerPath: payload,
  }))
  .handleAction(appendRouteLassoPath, (state, { payload }) => ({
    ...state,
    lasso: {
      ...state.lasso,
      allowAdd: state.lasso.paths.length < MAX_LASSO_PATHS - 1,
      paths: [...state.lasso.paths, payload],
    },
  }))
  .handleAction(cleanRouteLassoPaths, (state) => ({
    ...state,
    lasso: {
      ...state.lasso,
      allowAdd: true,
      containsClusters: false,
      paths: [],
    },
  }))
  .handleAction(setRouteLassoContainsFlags, (state, { payload }) => ({
    ...state,
    lasso: { ...state.lasso, ...payload },
  }))
  .handleAction(fetchRouteLassoSelection.request, (state) => ({
    ...state,
    lasso: { ...state.lasso, loading: true },
  }))
  .handleAction([fetchRouteLassoSelection.success, fetchRouteLassoSelection.failure], (state) => ({
    ...state,
    lasso: { ...state.lasso, loading: false },
  }))
  .handleAction(setRouteSelection, (state, { payload }) => ({
    ...state,
    selected: { ...state.selected, items: payload },
  }))
  .handleAction(setRouteSelectionEntities, (state, { payload }) => ({
    ...state,
    selected: { ...state.selected, entities: payload },
  }))
  .handleAction(restartRouteSelection, (state) => ({
    ...state,
    selected: {
      ...state.selected,
      entities: [],
      excluded: new Set<string>(),
      included: new Set<string>(),
      items: new Set<string>(),
    },
  }))
  .handleAction(clearRouteSelection, (state) => ({
    ...state,
    selected: { ...state.selected, entities: [], items: new Set<string>() },
  }))
  .handleAction(addToRouteSelection, (state, { payload }) => ({
    ...state,
    selected: {
      ...state.selected,
      excluded: new Set(
        payload instanceof Set
          ? Array.from(state.selected.excluded).filter((id) => !payload.has(id))
          : Array.from(state.selected.excluded).filter((id) => payload !== id)
      ),
      included: new Set(
        payload instanceof Set
          ? [...state.selected.included, ...payload]
          : [...state.selected.included, payload]
      ),
    },
  }))
  .handleAction(removeFromRouteSelection, (state, { payload }) => ({
    ...state,
    selected: {
      ...state.selected,
      excluded: new Set(
        payload instanceof Set
          ? [...state.selected.excluded, ...payload]
          : [...state.selected.excluded, payload]
      ),
      included: new Set(
        payload instanceof Set
          ? Array.from(state.selected.included).filter((id) => !payload.has(id))
          : Array.from(state.selected.included).filter((id) => payload !== id)
      ),
    },
  }));

export default toolsReducer;
